export default {"src":"/_next/static/media/house.378f2143.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};